import React, {Component} from 'react'
import classNames from 'classnames'
import Style from './FJExportIntro.module.less'
import ResizeSensor from "resize-sensor";
import InlineSVG from "react-inlinesvg";
import backRight from "../../../icon/back-right.svg";

class FJExportIntro extends Component {

  constructor(props) {
    super(props);
    this.state = {
      containerSize: {width: 160, height: 90}, // 预览容器的尺寸
      previewSize: {width: 160, height: 90}, // 实际预览区域的尺寸
    };
    this.rightIntroWidth = 546;
  }

  componentDidMount() {
    this._resizeSensor = new ResizeSensor(document.body, this.fitView);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isShow !== prevProps.isShow || this.props.ratioSize !== prevProps.ratioSize) {
      if (this.props.isShow) {
        this.fitView();
      }
    }
  }

  componentWillUnmount() {
    this._resizeSensor.detach();
  }


  previewSize = () => {
    return this.state.previewSize;
  };

  _fitSize = (outerSize, innerSize, float = false) => {
    let r1 = innerSize.width / innerSize.height;
    let r2 = outerSize.width / outerSize.height;
    let w;
    let h;
    if (r1 >= r2) {
      w = outerSize.width;
      h = w / r1;
    } else {
      h = outerSize.height;
      w = h * r1;
    }
    if (float) {
      return {width: w, height: h};
    } else {
      return {width: Math.floor(w), height: Math.floor(h)};
    }
  }

  fitView = (done = () => {}) => {
    const {isShow, ratioSize} = this.props;
    if (isShow) {
      let maxWidth = this.container.getBoundingClientRect().width;
      let containerWidth = maxWidth - this.rightIntroWidth;
      let containerHeight = Math.ceil(containerWidth / (16 / 9));
      let {width: previewWidth, height: previewHeight} = this._fitSize({
        width: containerWidth,
        height: containerHeight,
      }, ratioSize);
      this.setState({
        containerSize: {width: containerWidth, height: containerHeight},
        previewSize: {width: previewWidth, height: previewHeight},
      }, done);
    }
  };

  render() {
    let {
      backText,
      isShow,
      onRenderPreview,
      onRenderIntros,
    } = this.props;
    let {containerSize, previewSize} = this.state;
    let {onBack} = this.props;
    let containerClassName = classNames(Style.box, {[Style.active]: isShow});
    return (
      <div className={containerClassName}
           ref={ele => {this.container = ele}}>
        <div className={Style.back} onClick={onBack}>
          <InlineSVG src={backRight} element='div'/>
          <div className={Style.back_desc}>{backText}</div>
        </div>
        <div className={Style.content}>
          {
            onRenderPreview({
              containerSize,
              previewSize,
            })
          }
          {
            onRenderIntros({
              style: {width: this.rightIntroWidth},
            })
          }
        </div>
      </div>
    );
  }
}

export default FJExportIntro
